export default {
  computed: {
    isMyGudangSelected() {
      if (this.isAdminGudang && this.myGudang) {
        const findGudang = this.selectedGudangs.find(gudang => gudang.value == this.myGudang.id)
        if (findGudang) {
          return true
        }

        return false
      }
      return false
    },
    rincianSalesFields() {
      return [
        { key: 'remove', label: '#' },
        { key: 'barang', label: 'Barang', sortable: true },
        { key: 'qty_request', label: 'Request Saya', sortable: true },
        { key: 'spv_request', label: 'Request SPV', sortable: true },
        { key: 'sumStock', label: 'Stok Tersedia', sortable: true },
        { key: 'satuan', label: 'Satuan', sortable: true },
        { key: 'keterangan', label: 'keterangan', sortable: true },
      ]
    },
    rincianSpvFields() {
      return [
        { key: 'remove', label: '#' },
        { key: 'barang', label: 'Barang', sortable: true },
        { key: 'qty_request', label: 'Request Sales', sortable: true },
        { key: 'satuan', label: 'Satuan', sortable: true },
        { key: 'keterangan', label: 'keterangan', sortable: true },
      ]
    },
    rincianGudangFields() {
      return [
        {
          key: 'details',
          label: 'Detail Stok',
        },
        { key: 'barang', label: 'Barang', sortable: true },
        { key: 'qty_request', label: 'Request Sales', sortable: true },
        { key: 'spv_request', label: 'Request SPV', sortable: true },
        { key: 'sumStock', label: 'Stok Disetujui Gudang', sortable: true },
        { key: 'keterangan', label: 'keterangan', sortable: true },
      ]
    },
    rincianDefaultFields() {
      return [
        { key: 'remove', label: '#' },
        { key: 'barang', label: 'Barang', sortable: true },
        { key: 'qty_request', label: 'Request Sales', sortable: true },
        { key: 'spv_request', label: 'Request SPV', sortable: true },
        { key: 'satuan', label: 'Satuan', sortable: true },
        { key: 'keterangan', label: 'keterangan', sortable: true },
      ]
    },
    gudangStockSelectedCount() {
      if (!this.isAdminGudang || this.isSales || !this.rincianBarangs) {
        return { selected: 0, total: 0 }
      }
      const withStocks = this.rincianBarangs.filter(
        (r) => r.stocks && r.stocks.length > 0
      )
      const selected = withStocks.filter((r) =>
        (r.stocks || []).some((s) => s.selected)
      ).length
      return { selected, total: withStocks.length }
    },
  },
  methods: {
    getBarangSatuan(item) {
      if (!item || !item.barang) return ''
      const satuan = item.barang.satuan
      if (!satuan) return ''
      // Endpoint detail agregat mengirim satuan sebagai string; endpoint rincian lama sebagai objek.
      return typeof satuan === 'string' ? satuan : satuan.satuan || ''
    },
    getStockAvailableQty(stock) {
      if (!stock) return 0
      const qty = Number(
        stock.stok != null ? stock.stok : stock.jumlah != null ? stock.jumlah : 0
      )
      return Number.isFinite(qty) && qty > 0 ? qty : 0
    },
    syncApprovedQty(rincian) {
      if (!rincian) return 0
      const stocks = rincian.stocks || []
      const approvedQty = stocks.reduce((total, stock) => {
        if (!stock.selected) return total
        const qty = parseInt(stock.requestedStock, 10)
        return total + (Number.isFinite(qty) && qty > 0 ? qty : 0)
      }, 0)
      this.$set(rincian, 'approvedQty', approvedQty)
      // keep legacy sumStock in sync for any other consumers
      this.$set(rincian, 'sumStock', approvedQty)
      return approvedQty
    },
    autoAllocateStock(rincian) {
      if (!rincian || !rincian.stocks || rincian.stocks.length < 1) {
        if (rincian) {
          this.$set(rincian, 'approvedQty', 0)
          this.$set(rincian, 'sumStock', 0)
        }
        return 0
      }

      const target = Number(
        rincian.spv_request != null && rincian.spv_request !== ''
          ? rincian.spv_request
          : rincian.qty_request
      )
      let remaining = Number.isFinite(target) && target > 0 ? target : 0

      rincian.stocks.forEach((stock) => {
        const available = this.getStockAvailableQty(stock)
        if (remaining > 0 && available > 0) {
          const qty = Math.min(remaining, available)
          this.$set(stock, 'selected', true)
          this.$set(stock, 'requestedStock', qty)
          remaining -= qty
        } else {
          this.$set(stock, 'selected', false)
          this.$set(stock, 'requestedStock', 0)
        }
      })

      return this.syncApprovedQty(rincian)
    },
    autoAllocateAllRincian() {
      if (!this.rincianBarangs) return
      this.rincianBarangs.forEach((rincian) => {
        this.autoAllocateStock(rincian)
      })
    },
    async getGudangSales(requestBarang) {
      const gudang = await this.$store.dispatch('gudang/getData', {
        karyawan_id: requestBarang.sales ? requestBarang.sales.id : null,
        jenis: 2,
      })

      if (gudang && gudang.length > 0) {
        return gudang[0]
      }

      return null
    },
    /**
         * Get tujuan prop filter by Gudang from rincian barang (KHUSUS GUDANG)
         * @params rincian barang obj
         *
        */
    getTujuanFromRincian(rincian) {
      if (rincian.tujuan) {
        const tujuans = []
        rincian.tujuan.map(tujuan => {
          if (this.isAdminGudang && !this.isSales && tujuan.gudang_id == this.myGudang.id) {
            tujuans.push(tujuan)
          } else if (this.isSales) {
            tujuans.push(tujuan)
          }
        })
        return tujuans.reduce((total, item) => total += item.qty_request, 0)
      }
      return 0
    },
    updateRincianFields(availableGudangs, role = 'sales') {
      switch (role) {
        case 'sales':
          break
        case 'spv':
          const fields = this.rincianSpvFields
          const gudangFields = availableGudangs.map(gudang => ({ key: gudang.key, label: gudang.label }))
          fields.splice(4, 0, ...gudangFields)
          return fields
          break
      }
    },
    getPenyimpananReal(rincian) { // KHUSUS SALES
      const tujuans = Array.isArray(rincian && rincian.tujuan) ? rincian.tujuan : []
      if (!tujuans.length) return 0
      const last = tujuans[tujuans.length - 1]
      return last && last.qty_real != null ? Number(last.qty_real) || 0 : 0
    },
    getSelectedGudang(rincians) {
      const selectedGudangs = []

      rincians.map(rincian => {
        if (rincian.tujuan) {
          rincian.tujuan.map(tujuan => {
            selectedGudangs.push(tujuan.gudang_id)
          })
        }
      })

      return selectedGudangs
    },
    async setRincianDetail(rincians) { // for !spv to see request sales, request spv, and reqest gudang
      // Preload stok gudang dalam SATU request ringan (endpoint khusus /request-barang/{id}/stok).
      const stockByBarang = {}
      if (this.isAdminGudang && !this.isSales && rincians.length > 0) {
        const stocks = await this.$store.dispatch('requestbarang/getStokGudang', {
          id: this.$route.params.id,
          gudang_id: this.myGudang.id,
        })
        ;(stocks || []).forEach(stock => {
          const bid = stock.barang_id
          if (bid == null) return
          // normalisasi ke bentuk yang dipakai picker gudang (stock.id = id_penyimpanan)
          const normalized = {
            id: stock.id_penyimpanan,
            id_penyimpanan: stock.id_penyimpanan,
            barang_id: stock.barang_id,
            stok: stock.stok,
            jumlah: stock.stok,
            gudang: stock.gudang,
            blok: stock.blok,
            palet: stock.palet,
            rak: stock.rak,
            laci: stock.laci,
          }
          if (!stockByBarang[bid]) stockByBarang[bid] = []
          stockByBarang[bid].push(normalized)
        })
      }

      rincians.forEach((rincian) => {
        rincian.stocks = []
        rincian.sumStock = 0
        rincian.spv_request = this.getTujuanFromRincian(rincian)

        if (this.isAdminGudang && !this.isSales) {
          const bid = rincian.barang ? rincian.barang.id : null
          // clone tiap stok agar seleksi (selected/requestedStock) tidak bocor antar rincian barang sama
          rincian.stocks = bid != null && stockByBarang[bid]
            ? stockByBarang[bid].map(s => ({ ...s }))
            : []
          const tujuans = (rincian.tujuan || []).filter(t => t.gudang_id == this.myGudang.id)
          rincian.sumStock = tujuans.reduce((total, t) => total + (Number(t.qty_real) || 0), 0)
        }

        if (this.isSales) {
          rincian.sumStock = this.getPenyimpananReal(rincian)
        }
      })

      return rincians
    },
    setRincianGudang(rincians) { // for spv detailing rincian
      // check jika ada tujuan, maka tampilan per gudang nya
      const hasTujuan = rincians.some(rincian => rincian.tujuan != null)
      if (hasTujuan) {
        // store gudang for become new fields
        const availableGudangs = []

        // update fields per gudang
        rincians.map(rincian => {
          if (rincian.tujuan) {
            // search gudang for fields
            this.gudangs.map(gudang => {
              const findTujuan = rincian.tujuan.find(tujuan => tujuan.gudang_id == gudang.value)
              if (findTujuan) {
                const tujuanInGudang = this.selectedGudangs.find(sg => sg.value == findTujuan.gudang_id)
                if (!tujuanInGudang) { // dipaket if buat menghindari duplicate selected filter gudang
                  this.selectedGudangs.push({
                    value: findTujuan.gudang_id,
                    text: gudang.text,
                  })
                  this.rawSelectedGudangs.push({
                    value: findTujuan.gudang_id,
                    text: gudang.text,
                    new: true,
                  })
                }
                availableGudangs.push({
                  label: gudang.text,
                  value: findTujuan.gudang_id,
                  key: this.getShortName(gudang.text),
                  ...findTujuan,
                })
              }
            })
          }
        })

        if (availableGudangs.length > 0) {
          // update fields
          this.rincianFields = this.updateRincianFields(availableGudangs, 'spv')

          // update data
          rincians.map(rincian => {
            rincian.penyimpanan = [] // buat store field untuk gudang, 1 barang bisa jadi SPV ngisi untuk 1-2,... gudang
            rincian.spv_request = 0 // untuk ditampilkan sebagai jumlah request dari spv
            availableGudangs.map(gudang => {
              if (rincian.tujuan) {
                // tujuan propsper gudang
                const tujuanGudang = rincian.tujuan.filter(tujuan => tujuan.gudang_id == gudang.value)
                if (this.isSPV) {
                  rincian[gudang.key] = tujuanGudang.length > 0 ? tujuanGudang.reduce((total, item) => total += item.qty_request, 0) : 0
                }
                rincian.spv_request += tujuanGudang.length > 0 ? tujuanGudang.reduce((total, item) => total += item.qty_request, 0) : 0
              } else {
                rincian[gudang.key] = 0
              }
            })
          })
        }
      }

      return rincians
    },
  },
}
